<template>
<div class="chapter">
<div class="inner_page">
<p class="subtitle"><a id="page_iii"></a><span class="bold">VICTIMS OF THE</span></p>
<h1 class="title"><span class="bold">OAKS</span></h1>
<h1 class="subtitle1"><span class="bold">COLLIERY</span></h1>
<h1 class="subtitle2"><span class="bold">DISASTER 1847</span></h1>
<p class="author">JANE AINSWORTH</p>
<div class="pub"><img alt="images" src="images/f0iii-01.jpg"/></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Title.vue?93f5a904